<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TLE6cG/CoverDesign.jpg?1685327561584" alt="This image is the cover for the book His Leading Man, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Leading Man, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p>He wrote a comedy. Fate directed a romance. </p> <p>Drew Beaumont is bored of the same old roles: action hero, supervillain, romantic lead. He’s not going to let a fresh gay buddy comedy languish just because they can’t find him the right costar. No, Drew bats his eyelashes and convinces everyone that the movie’s writer should play Drew’s not-so-straight man.</p> <p>Aspiring writer Steve Sopol has never had a screenplay optioned. Now one of Hollywood’s hottest properties wants to be in a movie Steve hasn’t finished writing—and he wants Steve as his costar. Turns out the chemistry between them is undeniable—on and offscreen.</p> <p>Drew swore off dating in the biz, but Steve is the whole package: sharp, funny, humble, and cute. For Steve, though, giving in to the movie magic means the end of the privacy he cherishes. Will the credits roll before their ride into the sunset? </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashlyn Kane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79813c6e